export function AgendaCreationIcon({ series = false }: { series?: boolean }) {
  return (
    <svg className="agenda-page__creation-icon" viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {series ? <>
        <rect x="8" y="8" width="19" height="19" rx="1.5" />
        <path d="M8 14h19M12 5.5v5M22 5.5v5" />
        <rect x="3" y="15" width="19" height="17" rx="1.5" fill="var(--agenda-action-surface, #fff)" />
        <path d="M3 20.5h19M7 12.5v5M17 12.5v5" />
      </> : <>
        <rect x="3" y="10" width="23" height="23" rx="1.5" />
        <path d="M3 16h23M8 7v6M21 7v6" />
      </>}
      <circle cx="29" cy="7" r="6" fill="currentColor" stroke="none" />
      <path d="M26 7h6M29 4v6" stroke="white" strokeWidth="1.5" />
    </svg>
  );
}
